export const sanitizeEmail = (email: string) => {
  return email
    .replace('@@', '@')
    .replace(/[^a-zA-Z0-9._%+-@]/g, '')
    .toLowerCase();
};
